<template>
    <div>
        <div class="hidden-sm-and-down">
            <v-row v-show="store.state.user.role == 'admin'">
                <div>
                    <v-tabs
                        background-color="orange"
                        dark
                        v-model="componentKey"
                    >
                        <v-tab v-for="btn in buttons" :key="btn.id">
                            <v-btn text @click="$router.replace(btn.link)">
                                {{ btn.text }}
                            </v-btn>
                        </v-tab>
                        <v-tab>
                            <v-btn text dark @click="logout">Logga ut</v-btn>
                        </v-tab>
                    </v-tabs>
                </div>
            </v-row>
            <v-row v-show="store.state.user.role == 'user'">
                <v-btn text dark @click="$router.replace('/dashboard')"
                    >Mitt konto</v-btn
                >
                <v-btn text dark @click="$router.replace('/account/schedules')"
                    >Dina möten</v-btn
                >
                <v-btn text dark @click="$router.replace('/account/comments')"
                    >Kommentarer</v-btn
                >
                <v-btn text dark @click="$router.replace('/account/settings')"
                    >Inställningar</v-btn
                >
                <v-btn text dark @click="logout">Logga ut</v-btn>
            </v-row>
            <div v-show="!store.state.isLoggedIn">
                <router-link to="/login">
                    <v-btn text>
                        Logga in
                    </v-btn>
                </router-link>

                <router-link to="/register">
                    <v-btn text>Registrera</v-btn>
                </router-link>
            </div>
        </div>
        <div class="hidden-md-and-up">
            <v-list>
                <v-list-item>
                    <v-btn text @click="$router.replace('/dashboard')" v-show="store.state.user.role == 'user'"
                    >Mitt konto</v-btn
                >
                <v-btn text @click="$router.replace('/account/schedules')" v-show="store.state.user.role == 'user'"
                    >Dina möten</v-btn
                >
                <v-btn text @click="$router.replace('/account/comments')" v-show="store.state.user.role == 'user'"
                    >Kommentarer</v-btn
                >
                <v-btn text @click="$router.replace('/account/settings')" v-show="store.state.user.role == 'user'"
                    >Inställningar</v-btn
                >
                    <v-btn text v-show="store.state.isLoggedIn" @click="logout"
                        >Logga ut</v-btn
                    >
                    <div v-show="!store.state.isLoggedIn">
                        <v-list-item>
                            <router-link tag="p" to="/login">
                                <v-btn text>
                                    Logga in
                                </v-btn>
                            </router-link>
                        </v-list-item>
                        <v-list-item>
                            <router-link tag="p" to="/register">
                                <v-btn text>Registrera</v-btn>
                            </router-link>
                        </v-list-item>
                    </div>
                    <div v-show="store.state.user.role === 'admin'">
                        <v-list-item v-for="btn in buttons" :key="btn.id">
                            <router-link tag="p" :to="btn.link">
                                <v-btn text solid>
                                    {{ btn.text }}
                                </v-btn>
                            </router-link>
                        </v-list-item>
                    </div>
                </v-list-item>
            </v-list>
        </div>
    </div>
</template>

<script>
import store from "../../store";
export default {
    data: () => ({
        componentKey: 0,
        store: store,
        name: "navbtns",
        buttons: [
            {
                id: 0,
                text: "Översikt",
                link: "/admin/dashboard"
            },{
                id: 1,
                text: "Annons",
                link: "/admin/ads"
            },
            {
                id: 2,
                text: "Scheman",
                name: "schedules",
                link: "/admin/schedules"
            },
            {
                id: 3,
                text: "Användare",
                link: "/admin/users"
            },
            {
                id: 4,
                text: "Ändra lösenord",
                link: "/admin/changepassword"
            },
            {
                id: 5,
                text: "Post",
                link: "/admin/mails"
            }
        ]
    }),
    methods: {
        logout: function() {
            this.store.dispatch("logout");
            this.$router.replace("/");
        }
    }
};
</script>

<style scoped>
.highlight {
    color: white;
}
</style>
